<div id="loadingLov" *ngIf="showLoading">
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <!-- Loading -->
</div>